import { FormlyFieldConfig } from '@ngx-formly/core';
import { advancedSection, COMMON_FIELD_CONFIGS } from './field-config-shared';

/**
 * email: type → label → required → [Advanced: width, placeholder, prefillLastValue]
 *
 * No pattern field — HTML5 type="email" enforces standard email validation.
 */
export function getEmailFieldConfigFields(): FormlyFieldConfig[] {
  return [
    COMMON_FIELD_CONFIGS['type'],
    COMMON_FIELD_CONFIGS['label'],
    COMMON_FIELD_CONFIGS['required'],
    advancedSection(
      COMMON_FIELD_CONFIGS['width'],
      COMMON_FIELD_CONFIGS['placeholder'],
      COMMON_FIELD_CONFIGS['prefillLastValue'],
    ),
  ];
}
